<template>
  <div>
    <div v-show="isActive">
      <slot>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: {
        required: true
      },
      selected: {
        default: false
      },
      prefix: { default: '' },
      suffix: { default: '' }
    },
    data () {
      return {
        isActive: false
      }
    },
    computed: {
      header () {
        return this.prefix + this.name + this.suffix
      }
    },
    mounted () {
      this.isActive = this.selected
    }
  }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// tabChildComponent.vue?497cf842